export default [
  {
    path: '/ticket/:code',
    name: 'ticket.code',
    component: () => import('views/private/ticket/TicketCode'),
    meta: {
      requiresAuth: true,
    },
  },
];
